// extracted by mini-css-extract-plugin
module.exports = {"grouping":"SensorTypeChip_grouping__35wVR","icon":"SensorTypeChip_icon__1iO6-","text":"SensorTypeChip_text__2g44U","secondaryText":"SensorTypeChip_secondaryText__OcLyP"};